import { c as _c } from "react/compiler-runtime";
import { ListingCard } from "@/components/cards/listing-card";
import type { ListingCardProps } from "@/components/cards/listing-card";
import type { ListingItem } from "./directory-listing.types";
interface DirectoryFeaturedRowProps {
  featured: ListingItem;
  side: ListingItem[];
  mapToCardProps: (item: ListingItem) => ListingCardProps;
}
const featuredImageClass = "desktop:[&>div:first-child]:h-auto";
const FEATURED_IMAGE_SIZES = "(max-width: 1024px) 100vw, (max-width: 1280px) 66vw, 50vw";
const FEATURED_IMAGE_CROP_ASPECT = 645 / 578;
const SIDE_IMAGE_SIZES = "(max-width: 1024px) 100vw, (max-width: 1280px) 33vw, 25vw";
export function DirectoryFeaturedRow(t0) {
  const $ = _c(13);
  const {
    featured,
    side,
    mapToCardProps
  } = t0;
  let t1;
  if ($[0] !== featured || $[1] !== mapToCardProps) {
    t1 = mapToCardProps(featured);
    $[0] = featured;
    $[1] = mapToCardProps;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="col-span-4 tablet:col-span-8 desktop:col-span-6"><ListingCard {...t1} className={featuredImageClass} imageSizes={FEATURED_IMAGE_SIZES} imageCropAspect={FEATURED_IMAGE_CROP_ASPECT} /></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== mapToCardProps || $[6] !== side) {
    let t4;
    if ($[8] !== mapToCardProps) {
      t4 = item => <div key={item._id} className="col-span-4 tablet:col-span-4 desktop:col-span-3"><ListingCard {...mapToCardProps(item)} imageSizes={SIDE_IMAGE_SIZES} /></div>;
      $[8] = mapToCardProps;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t3 = side.slice(0, 2).map(t4);
    $[5] = mapToCardProps;
    $[6] = side;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = <div className="col-span-full grid grid-cols-subgrid gap-x-4 gap-y-6 tablet:gap-x-6">{t2}{t3}</div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}